module.exports = __webpack_public_path__ + "img/aso2.1749e38c.png";